module.exports = __webpack_public_path__ + "img/android-studio.62ea29ae.svg";